webpackJsonp([70144966829960],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-12 mb-5' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Contact'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Have a question? If you haven\'t found the answer to your question in ',
	      _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/faq' },
	          'FAQ'
	        )
	      ),
	      ', ',
	      _react2.default.createElement('br', null),
	      'feel free to shoot me an e-mail at: ',
	      _react2.default.createElement(
	        'b',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:getreptapp@gmail.com', subject: 'Help with RePT' },
	          'getreptapp@gmail.com'
	        )
	      ),
	      '.'
	    ),
	    props.children
	  );
	};
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Contact = __webpack_require__(125);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {};
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handleMessageChange = _this.handleMessageChange.bind(_this);
	    return _this;
	  }
	
	  ContactPage.prototype.handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    if (!event.target.checkValidity()) {
	      this.setState({ displayErrors: true });
	      return;
	    }
	
	    var formData = new FormData();
	    formData.append('_email', this.state.email);
	    formData.append('_message', this.state.message);
	    this.setState({ isSentSuccessfully: true });
	
	    fetch('https://api.codehacker.se/mail.php', {
	      method: 'POST',
	      body: formData
	    }).catch(function (error) {
	      return console.error('Fetch Error =\n', error);
	    });
	  };
	
	  ContactPage.prototype.handleEmailChange = function handleEmailChange(e) {
	    this.setState({ email: e.target.value });
	  };
	
	  ContactPage.prototype.handleMessageChange = function handleMessageChange(e) {
	    this.setState({ message: e.target.value });
	  };
	
	  ContactPage.prototype.render = function render() {
	    var displayErrors = this.state.displayErrors;
	
	    return _react2.default.createElement(_Contact2.default, null);
	    // if (this.state.isSentSuccessfully) {
	    //   return (
	    //     <Contact>
	    //       <h2 className='mt-5'>Thank you for your message!</h2>
	    //     </Contact>
	    //   )
	    // }
	
	    // return (
	    //   <Contact>
	    //     <form onSubmit={this.handleSubmit} noValidate className={displayErrors ? 'mt-5 displayErrors' : 'mt-5'}>
	
	    //       <div className='form-group'>
	    //         <label htmlFor='emailAddress'>Email address</label>
	    //         <input type='email' className='form-control' id='emailAddress' aria-describedby='emailHelp' placeholder='Enter email' required value={this.state.email || ''} onChange={this.handleEmailChange} />
	    //         <small id='emailHelp' className='form-text text-muted'>We'll never share your email with anyone else.</small>
	    //       </div>
	
	    //       <div className='form-group'>
	    //         <label htmlFor='messageBox'>Your message</label>
	    //         <textarea className='form-control' id='messageBox' rows='5' required value={this.state.message || ''} onChange={this.handleMessageChange} />
	    //       </div>
	    //       <button type='submit' className='btn btn-primary'>Submit</button>
	    //     </form>
	    //   </Contact>
	    // )
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-ec1b74dc3dce71d19d7e.js